exports.cs = {
  UNIFORM_DETAIL: {
    DROPDOWN: 'Vyberte položku...',
    INVALID_INPUT: 'Pole není vyplněno správně.',
    INVALID_CHECKBOX: 'Označte alespoň jednu z možností.',
    INVALID_RADIO: 'Vyberte jednu z možností.',
    INVALID_TEXTAREA: 'Pole není vyplněno správně.',
    INVALID_COMBOBOX: 'Vyberte jednu z možností.',
    INVALID_POBOCKY: 'Vyberte pobočku ze seznamu.',
    INVALID_FILE: 'Vyberte soubor z vašeho zařízení.',
    FILES_EXCEEDED: 'Byl překročen maximální počet příloh. Nebyly nahrány soubory: ',
    FILE_UPLOAD: 'Vybrat soubor',
    FILES_UPLOADED: 'Přidali jste %{filesAdded} soubory',
    FILES_UPLOADED2: 'Přidali jste %{filesAdded} souborů',
    DELETE_FILES: 'Smazat soubory',
    INVALID_DATEPICKER: 'Zadejte datum v požadovaném formátu.',
    ATTACHMENT_INVALIDEXTENSION: 'Vybraný soubor není v požadovaném formátu.',
    ATTACHMENT_MAXSIZEEXCEEDED: 'Soubor překročil maximální povolenou velikost',
    ATTACHMENT_MAXFILENAMELENGTHEXCEEDED: 'Název souboru nesmí mít více než 50 znaků. Zkuste jej před nahráním přejmenovat.',
    ATTACHMENT_MAX_TIME_EXCEEDED: 'Doba odesílání překročila povolenou mez.',
    ERROR_FORM: 'Chyba při načítaní fomuláře.',
    ERROR_REQUIRED: 'Zadejte prosím požadované údaje.',
    ERROR_PATTERN: 'Údaje nejsou ve správném formátu.',
    ERROR_MINLENGTH: 'Zkuste zadat více znaků.',
    ERROR_MAXLENGTH: 'Zkuste zadat méně znaků.',
    FORM_NOT_VALID: 'Formulář nelze odeslat. Vyplnili jste vše správně?',
    INVALID_BIRTHNUMBER_MODULO: 'Zadali jste rodné číslo ve špatném formátu.',
    POBOCKY_PLACEHOLDER: 'Vyberte pobočku ze seznamu...',
    POBOCKY_NO_RESULTS: 'Nebylo nic nalezeno.',
    ERROR_BACKEND: 'Omlouváme se, ale formulář je momentálně nedostupný. Kontaktujte nás na bezplatné lince 800 207 207.',
    STEPS: {
      BUTTON_PREVIOUS: 'Předchozí krok',
      BUTTON_NEXT: 'Další krok'
    }
  }
}
